import { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';
import { useTaxpayerAuthenticationConfig } from '../../hooks/hacienda/useTaxpayerAuthenticationConfig';
import TaxpayerAuthenticationFormComponent from '../../components/Hacienda/TaxpayerAuthenticationFormComponent';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const TaxpayerAuthenticationConfigPage = () => {
  const {
    form,
    error,
    isLoading,
    isSubmitting,
    updateField,
    loadConfiguration,
    saveConfiguration,
    loadSystemTaxId,
  } = useTaxpayerAuthenticationConfig();

  // 🔄 Cargar configuración al montar
  useEffect(() => {
    const init = async () => {
      const response = await loadConfiguration();

      // Si no existe config → cargar NIT de empresa
      if (!response?.data?.id) {
        await loadSystemTaxId();
      }
    };

    init();
  }, []);

  // 🖊️ Cambios en inputs
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateField(name as keyof typeof form, value);
  };

  // 💾 Guardar → Always active = true
  const handleSave = async () => {
    await saveConfiguration({
      ...form,
      active: true, // 🔥 Forzamos siempre activo
    });
  };

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <TaxpayerAuthenticationFormComponent
          form={form}
          errors={error ? { general: error } : {}}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          onChange={handleChange}
          onSave={handleSave}
        />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default TaxpayerAuthenticationConfigPage;
